module.exports = __webpack_public_path__ + "img/LOGO.93ad7df8.svg";